export enum LoginErrorEvent {
  LoginError = 'Login error',
}
